import RpcService  from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

/**
 * DAO для работы с категориями партнёров
 */
class PartnerCategoriesDAO {

	/**
	 * Загружает список категорий партнёров
	 */
	static async getList(): Promise<RpcResponse> {
		return await RpcService.makeRequest('partnerCategories.getList');
	}
}

export default PartnerCategoriesDAO;